import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const IconWrapper = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(30),
  display: 'flex',
  alignItems: 'center',
}));
